export class UpdateWorkflowActionRequest {
  WorkflowID: number = -1;
  WorkflowActionID: number = -1;
  Title: string = '';
  Description: string = '';
  DefaultOwnerUserID?: number | null;
  DefaultOwnerTypeID?: number | null;
  DefaultDueInDays?: number | null;
  IsMandatory: boolean = false;
  ActionVariationID: number = 1;
  AuditID?: number | null;

  constructor(values: Partial<UpdateWorkflowActionRequest> = {}) {
    Object.assign(this, values);
  }
}
